/**
 * MY — Resignation of Secretary (M32107) Register Detail 매핑.
 * TASK_DATA.formData.secretaries[] (또는 presetForm.values 폴백으로 빌드된 secretaries) 사용.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';
import { formatDocDate } from '@/shared/composables/dateUtils';

function formatSessionDate(raw: any): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  try {
    return formatDocDate(s) || s;
  } catch {
    return s;
  }
}

registerRegisterDetail('M32107', {
  title: 'Resigning Secretary Details',
  repeatArrayPath: 'secretaries',
  fields: [
    { label: 'Full Name', key: ['secretaries.0.fullName'] },
    { label: 'NRIC / Passport No', key: ['secretaries.0.nricOrPassport'] },
    { label: 'License Type', key: ['secretaries.0.licenseType'] },
    { label: 'License No', key: ['secretaries.0.licenseNumber'] },
    { label: 'SSM PC No', key: ['secretaries.0.ssmPcNo'] },
    {
      label: 'Date of Appointment',
      key: ['secretaries.0.appointmentDate', 'secretaries.0.dateOfAppointment'],
      format: formatSessionDate,
    },
    {
      label: 'Date of Cessation',
      key: [
        'secretaries.0.dateOfCessation',
        'secretaries.0.cessationDate',
        'secretaries.0.date_of_cessation',
      ],
      format: formatSessionDate,
    },
    { label: 'Residential Address', key: ['secretaries.0.residentialAddress'] },
    {
      label: 'Reason for cessation',
      key: ['secretaries.0.reasonForCessation', 'secretaries.0.reason'],
    },
  ],
});
